import * as Yup from "yup";

let validationSchema = Yup.object({
  email: Yup.string("Email is Required")
    .required("Email is Required")
    .email("Email Must be Valid"),
  password: Yup.string().required("Password is Required"),
});
export default validationSchema;
